import {
  CSSProperties, LegacyRef,
  ReactNode,
  useEffect,
  useRef
} from 'react';

type Props = {
  isHide: boolean;
  setIsHide?: (e: boolean) => void;
  position?: string;
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
  layout?: CSSProperties
  handleClose?: () => void;
};

function Index({
  isHide,
  setIsHide,
  className,
  style,
  layout,
  position,
  handleClose,
  ...props
}: Readonly<Props>) {
  const myRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      const target = e.target as HTMLElement;
      if (myRef.current && !myRef.current.contains(e.target as Node) && setIsHide) {
        setIsHide(false);
      } else if (handleClose && target.classList.contains('boardList-BoardInfo')) {
        handleClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      id="custom-option"
      ref={myRef as unknown as LegacyRef<HTMLDivElement>}
      className={`${position ?? 'custom_option_search'} ${isHide ? 'show' : ''} ${className}`}
      style={style}
    >
      <div className="layout_item_search scroll_custom_search" style={layout}>
        {props?.children}
      </div>
    </div>
  );
}

export default Index;
